import { MantineSupportedColors, RequirementType } from '@care-portals/api-interfaces';

// Hard coding cover config; this is deprecated as cover health is moving to use the CRM booking
const SLOT_DURATION_IN_MINUTES = 60; // in minutes

export const CONSTANTS = {
  slotsDurationInMinutes: SLOT_DURATION_IN_MINUTES, // in minutes
  dailySlotsCount: 1440 / SLOT_DURATION_IN_MINUTES, // # slots per day
  capacityPerSlot: 6
};

export const CRON_RATE = 30; // must match the cron rate in serverless.yml
export const ORG_TIMEZONE = 'America/Toronto'; //default ORG timezone

export const IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'image/png'
];

export const PortalsColors: Record<MantineSupportedColors, string> = {
  teal: '#12b886',
  green: '#40c057',
  lime: '#82c91e',
  yellow: '#fab005',
  orange: '#fd7e14',
  blue: '#74c0fc',
  cyan: '#15aabf',
  red: '#fa5252',
  pink: '#e64980',
  grape: '#eebefa',
  violet: '#7950f2',
  indigo: '#4c6ef5',
  dark: '#2e2e2e',
  gray: '#868e96'
};

export const PATIENT_DOCUMENT_TYPES = {
  GOV_ID: 'govid',
  SELFIE: 'selfie',
  BODY_SELFIE: 'bodyselfie'
};

export const REQUIREMENT_DEFAULT_VALIDITY_DAYS = 30;

export const REQUIREMENT_TYPE_OPTIONS: { [x in RequirementType]: string } = {
  qnr: 'QNR',
  appointment: 'Appointment',
  verification: 'Verification',
  lab_test: 'Lab Test',
  placeholder: 'Placeholder'
};
